import { apiClient } from "../HttpClient";
import { API_GET_HOST_ORDERS_BY_PROPERTY, API_GET_INVOICE_BY_BOOKING } from "../config";
import { CategorizedBookings } from "../../types/bookingTypes";

export const getOrdersByProperty = async (propertyId: string): Promise<CategorizedBookings> => {
  try {
    const url = API_GET_HOST_ORDERS_BY_PROPERTY.replace("propertyID", propertyId.toString());
    const client = await apiClient;
    const response = await client.get<CategorizedBookings>(url);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getInvoiceByBooking = async (bookingId: string): Promise<any> => {
  try {
    const url = API_GET_INVOICE_BY_BOOKING.replace("bookingId", bookingId);
    const client = await apiClient;
    const response = await client.get(url, { responseType: 'blob' });
    return response;
  } catch (error) {
    throw error;
  }
};
